enum SampleType {
  BIOENTITY = 'BIOENTITY',
  BATCH = 'BATCH',
}
// This stays separate because it's only a valid sample type in some instances
export const CONTAINER_SAMPLE = 'CONTAINER';

export const SAMPLE_TYPE_DISPLAY = {
  [SampleType.BIOENTITY]: 'entity',
  [SampleType.BATCH]: 'batch',
  [CONTAINER_SAMPLE]: 'container',
};

export default SampleType;
